module.exports = __webpack_public_path__ + "static/media/P1000.8d86ba2e.svg";